import { useDataValue } from 'Simple/Data.js'
/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    context: 'plan_details',
    viewPath: props.viewPath,
    path: 'billing_center',
  })
  return {
    variables: { id },
  }
}
